'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("saisieChampAdditionnel", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      cible: "@cible",
      classifications: "@"
    },
    template: require("./saisieChampAdditionnel.html"),
    link: function link($scope, $el, $attrs) {},
    controller: function controller($scope, $q, $http, $modal, $compile, $applications, $element, $session, budgetService, contextService, $dialogBox, classificationService, tlTableUtils, $notifications, $rootScope, $location, pageStatus) {
      var urlRoot = '/rest/saisie/champAdditionnel';
      $scope.moduleSubvention = $applications.isAideSubventionApplication();
      var load = function load() {
        return $http.get(urlRoot + "/champsLibresPourCible/" + $scope.cible, {
          params: {
            avecClassifications: true
          }
        }).then(function (response) {
          $scope.champs = response.data;
          $scope.selectedChamp = tlTableUtils.getNewTableSelection($scope.selectedChamp, $scope.champs);
          if ($scope.selectedChamp == null && $scope.champs.length > 0) {
            // idealement ce serait plutôt la première ligne du tableau (peu importe les tris) qu'on voudrait voir sélectionnée
            $scope.selectedChamp = $scope.champs[0];
          }
        });
      };
      $scope.sortableOptions = {
        axis: 'y',
        handle: '.grip',
        cancel: '.grip.disabled',
        items: "tr:has(.grip)",
        placeholder: "sortable-placeholder",
        start: function start(e, ui) {
          // Sélectionne la ligne dès le début du déplacement pour un retour visuel immédiat.
          $scope.$apply(function () {
            $scope.selectedChamp = ui.item.scope().model;
          });

          // L'assistant est un clone, on doit lui ajouter manuellement la classe de sélection
          // pour qu'il ait la bonne couleur pendant le déplacement.
          ui.helper.addClass('selected');

          // Ajuste la hauteur du placeholder pour correspondre à l'élément déplacé
          ui.placeholder.height(ui.item.height());
        },
        stop: function stop(e, ui) {
          // L'ID de l'élément qui a été déplacé.
          var movedChampId = ui.item.scope().model.id;
          var orderedIds = $scope.champs.map(function (champ) {
            return champ.id;
          });
          $scope.submitting = true;
          $http.post('/rest/saisie/champAdditionnel/reorder', orderedIds).then(function () {
            classificationService.$reload();
            //load().then(() => {
            $notifications.info('Ordre des champs mis à jour.');
            // Resynchronise la sélection avec l'objet de la nouvelle liste pour éviter les données périmées.
            var newSelectedChamp = $scope.champs.find(function (c) {
              return c.id === movedChampId;
            });
            if (newSelectedChamp) {
              $scope.selectedChamp = newSelectedChamp;
            }
            //});
          }).catch(function () {
            $notifications.error('Erreur lors de la mise à jour de l\'ordre des champs.');
            load();
          }).finally(function () {
            $scope.submitting = false;
          });
        },
        helper: function helper(e, tr) {
          var $originals = tr.children();
          var $helper = tr.clone();
          $helper.children().each(function (index) {
            $(this).width($originals.eq(index).width());
          });
          return $helper;
        }
      };
      var unwatchEditChamp;
      var watchEditChamp = function watchEditChamp() {
        unwatchEditChamp = $scope.$watch('editChamp', function (newVal, oldVal) {
          if ($scope.editChamp && oldVal != null && oldVal !== newVal) {
            console.log('$scope.editChamp dirty', newVal, oldVal);
            $scope.editChamp.$dirty = true;
          }
        }, true);
      };
      watchEditChamp();
      var cible = $scope.cible;
      var labelNommageCible = "?";
      if (cible === 'PRODUIT') {
        if ($scope.moduleSubvention) {
          labelNommageCible = "subvention";
        } else {
          labelNommageCible = "produit";
        }
      } else {
        labelNommageCible = cible === 'COMPTE' ? "entité" : cible === 'PROJET' ? "projet" : "contrepartie";
      }
      $scope.typesClassification = [];
      $scope.typesClassification.push({
        id: 'SIMPLE',
        label: "Une valeur par " + labelNommageCible
      });
      if (cible !== 'CONTREPARTIE') {
        $scope.typesClassification.push({
          id: 'MULTIPLE',
          label: "Plusieurs valeurs par " + labelNommageCible
        });

        // pour le moment pas de classif répartissables sur le module subvnetion
        if (!$scope.moduleSubvention) {
          $scope.typesClassification.push({
            id: 'REPARTITION',
            label: "Valeurs répartissables en % par " + labelNommageCible
          });
        }
      }

      /**
       * a chaque changement de selection on doit desactiver le watch de l'edit pour le changer
       */
      function updateEditChampWithSelectedChamp() {
        // on debranche le watch pour pouvoir modifier l'edit sans le marquer en dirty
        unwatchEditChamp();
        if (!$scope.selectedChamp) {
          $scope.editChamp = null;
        } else {
          $scope.editChamp = _.extend({}, $scope.selectedChamp);
        }
        // et on le rebranche
        watchEditChamp();
      }
      var watchChamp = function watchChamp() {
        $scope.$watch('selectedChamp', function (newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          updateEditChampWithSelectedChamp();
        });
      };
      watchChamp();
      $scope.selectChamp = function (champ, $event) {
        // Si le clic provient de la poignée de déplacement, on ne fait rien pour laisser le drag-and-drop s'activer.
        if ($event && $($event.target).hasClass('grip')) {
          return;
        }
        if ($scope.editChamp && $scope.editChamp.$dirty) {
          $dialogBox.alert({
            title: "Vous avez des modification non sauvegardée.",
            text: "Veuillez sauvegarder ou annuler vos modifications avant de changer de champ additionnel"
          });
          if ($event) $event.stopPropagation();
          return;
        }
        $scope.selectedChamp = champ;
      };
      $scope.addChamp = function () {
        classificationService.openChampAdditionnelCreationPopin($scope.cible).then(function (response) {
          // pour permettre de sélectionner le champ créée
          $scope.selectedChamp = {
            id: response.id
          };
          load();
          pageStatus.invalidate();
          classificationService.$reload();
        });
      };
      $scope.annulerModifications = function () {
        updateEditChampWithSelectedChamp();
        $notifications.info('Modifications annulées');
      };
      $scope.save = function () {
        $scope.errors = null;
        $scope.submitting = true;
        $http.post('/rest/saisie/champAdditionnel', $scope.editChamp).then(function (response) {
          var validation = response.data;
          if (validation.valid) {
            return load().then(function () {
              $notifications.info('Modifications enregistrées');
              updateEditChampWithSelectedChamp();
              pageStatus.invalidate();
              classificationService.$reload();
            });
          } else {
            $scope.errors = validation.errors;
            $element.find(".libelle")[0].scrollIntoView({
              block: "start",
              inline: "nearest",
              behavior: "smooth"
            });
          }
        }).finally(function () {
          $scope.submitting = false;
        });
      };
      $scope.editClassificationValue = function (classification) {
        classificationService.openEditionValeursPopin(classification).then(function () {
          load();
          pageStatus.invalidate();
          classificationService.$reload();
        });
      };
      $scope.deleteChamp = function (champ) {
        if ($scope.editChamp.$dirty) {
          //$notifications.warn("Veuillez sauvegarder ou annuler vos modifications avant de supprimer le champ")
          return;
        }
        $dialogBox.confirm({
          title: "Suppression d'un champ additionnel",
          text: "Êtes-vous sûr de vouloir supprimer le champ additionnel '" + champ.nom + "' ?"
        }).then(function () {
          classificationService.delete(champ.id).then(function (response) {
            if (response.valid) {
              $notifications.info("Champ additionnel " + champ.nom + " supprimé.");
              load();
              classificationService.$reload();
            }
          });
        });
      };
      var forcePageQuit = false;
      // show confirm dialog on location change is produit has been modified since last save.
      $rootScope.$on("$locationChangeStart", function (event, next, current) {
        var showDialog = !(forcePageQuit || !($scope.editChamp && $scope.editChamp.$dirty));
        if (showDialog) {
          event.preventDefault();
          $dialogBox.confirm({
            title: "Modifications non sauvegardées",
            text: "Le champ additionel contient des modification non sauvegardées. Si vous quittez maintenant, " + "toutes les modifications seront perdues. Êtes-vous sûr de vouloir quitter ?"
          }).then(function () {
            forcePageQuit = true;
            $scope.annulerModifications();
            $location.$$parse(next);
          });
        }
      });
      load();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/champAdditionnel/saisieChampAdditionnel.js
// module id = 2685
// module chunks = 13